import schemaDomain from '@/domains/schema'
import sdkDomain from '@/domains/sdk'

import authDomain from './auth'
import documentDomain from './document'
import projectDomain from './project'
import readmeDomain from './readme'
import registryDomain from './registry'
import teamDomain from './team'
import upgradeCmd from './upgrade'

const domains = [
  readmeDomain,
  upgradeCmd,
  authDomain,
  documentDomain,
  projectDomain,
  registryDomain,
  teamDomain,
  sdkDomain,
  schemaDomain,
]

export default domains
